<template lang="pug">
  div
    b-form(@submit.prevent="handleSubmit")
      b-alert(v-if="!result" show variant="info")
        | Se sincronizará con el partner
        b  {{ deliveryIds.length }}
        |  envíos seleccionados.
      b-alert(v-if="result" show :variant="result.error ? 'danger' : 'success'")
        div(v-if="result.error")
          p.mb-1 ❌ {{ result.error }}
        div(v-else)
          p.mb-1 ✅ {{ result.message }}
          p.mb-1(v-if="result.synced && result.synced.length") ✔ Sincronizados: {{ result.synced.join(', ') }}
          p.mb-1(v-if="result.failed && result.failed.length")
            | ❌ Fallidos:
            ul.mb-0
              li(v-for="f in result.failed" :key="f.id") ID {{ f.id }}: {{ f.error }}
          p.mb-1(v-if="result.notFound !== undefined")
            small ⚠️ {{ result.notFound }} de {{ deliveryIds.length }} envíos no fueron encontrados (sin partner asignado)
      .d-flex.justify-content-end
        b-button(
          type="submit"
          variant="primary"
          :disabled="loading || !!result"
        )
          span(v-if="loading")
            b-spinner(small)
            |  Sincronizando...
          span(v-else) Sincronizar con Partner
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    deliveryIds: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      result: null
    }
  },
  methods: {
    ...mapActions(['bulkSyncPartner']),
    async handleSubmit() {
      this.loading = true
      this.result = null
      try {
        const response = await this.bulkSyncPartner({ deliveryIds: this.deliveryIds })
        this.result = response.data
        this.$emit('done')
      } catch (err) {
        this.result = {
          error: err.response?.data?.message || 'Error al sincronizar con el partner'
        }
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
    deliveryIds() {
      this.result = null
    }
  }
}
</script>
